<template>
  <div class="home content-wrapper">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <HomeProjects msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import HomeProjects from "@/components/HomeProjects.vue";

export default {
  name: "Home",
  components: {
    HomeProjects
  },
  beforeCreate: function() {
    document.body.className = "home";
  }
};
</script>

<style lang="scss">
@media screen and (min-device-width: 768px) {
  .content-wrapper {
    display: block;
    width: 75vw;
    // padding: 3.1vw;
  }
}
</style>
